export { default as NbPopover } from './NbPopover';
export type { NbPopoverProps } from './types';
